import { render, staticRenderFns } from "./ViewAllProposalsModal.vue?vue&type=template&id=54a1c412&"
import script from "./ViewAllProposalsModal.vue?vue&type=script&lang=js&"
export * from "./ViewAllProposalsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports